import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecentAchievements = ({ achievements, onOpenDetail }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          최근 업적
        </h2>
        <Icon name="Award" size={20} color="var(--color-accent)" />
      </div>
      <div className="space-y-3">
        {(!achievements || achievements.length === 0) && (
          <div className="p-4 bg-muted/30 rounded-md border border-border">
            <p className="text-sm text-muted-foreground caption">최근 증명이 아직 없습니다.</p>
          </div>
        )}
        {achievements?.map((achievement) => (
          <button
            key={achievement?.id}
            type="button"
            onClick={() => onOpenDetail?.(achievement?.id)}
            className="w-full text-left flex items-start space-x-3 md:space-x-4 p-3 md:p-4 bg-muted/50 rounded-md transition-gaming hover:bg-muted"
          >
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-md overflow-hidden">
              <Image
                src={achievement?.proofImage}
                alt={achievement?.proofImageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between mb-1">
                <h3 className="text-sm md:text-base font-medium text-foreground truncate">
                  {achievement?.title}
                </h3>
                <div className="flex items-center space-x-1 ml-2 px-2 py-1 rounded-full bg-primary/10 border border-primary/20">
                  {[...Array(achievement?.stars)]?.map((_, i) => (
                    <Icon
                      key={i}
                      name="Star"
                      size={12}
                      color="currentColor"
                      className="fill-current text-primary"
                    />
                  ))}
                </div>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground caption mb-2 line-clamp-2">
                {achievement?.description}
              </p>
              <div className="flex items-center space-x-3 text-xs text-muted-foreground caption">
                <span>{achievement?.projectName}</span>
                <span>•</span>
                <span>{achievement?.date}</span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecentAchievements;